import { ChangeEvent } from "react";
import { alpha as muiAlpha } from "@mui/material";
import { blue, orange, purple } from "@mui/material/colors";
import { ProfileRole } from "../ts/enums";

export const unpackEventTarget = (
  args: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  callback: (args: string) => void
): void => {
  callback(args.target.value);
};
export function backgroundAlpha(colour: string): string {
  if (!colour) return "";
  return muiAlpha(colour, 0.6);
}
export function borderAlpha(colour: string): string {
  if (!colour) return "";
  return muiAlpha(colour, 0.8);
}

export const getColorForRole = (role: ProfileRole | undefined) => {
  switch (role) {
    case ProfileRole.Member:
      return blue[500];
    case ProfileRole.Switch:
      return orange[500];
    case ProfileRole.Owner:
      return purple[500];
    default:
      return blue[500];
  }
};
